const Header = {
  init() {
    let _this = this;

    const header = document.getElementById('header');

    window.addEventListener('scroll', () => {
      const pageY = window.pageYOffset;
      const action = pageY > 100 ? 'add' : 'remove';
      header.classList[action]('scrolled');
    });

    $('#burger').click(function () {
      _this.toggleMobileNav();
    });

    $('.slide-menu__row').click(function () {
      $(this).find('.slide-menu--check').toggleClass('rotate'),
        $(this).next().slideToggle();
    });
  },

  toggleMobileNav() {
    if ($('#burger').hasClass('open')) {
      this.closeMobileNav();
    } else {
      this.openMobileNav();
    }
  },

  openMobileNav() {
    $('#burger').addClass('open');
    $('#mobile-menu').addClass('open');
  },

  closeMobileNav() {
    $('#burger').removeClass('open');
    $('#mobile-menu').removeClass('open');
  },
};

export default Header;



// WEBPACK FOOTER //
// ./scripts/components/header.js